<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" :save-params="{course}">
        <div class="row">
            <div class="col-12">
                <validated-input label="Topic" v-model="model.topic"
                                 :rules="{required: true, max:100}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-input type="number" label="Theory" v-model="model.theory"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-input type="number" label="Practical" v-model="model.practical"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Description" v-model="model.description"
                                     :rules="{required: true}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" text="Save" loading-text="Saving..." size="sm" :disabled="loading" :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>

import urls from '../../../../data/urls';

export default {
    props: {
        course: { type: String }
    },
    name: 'AddCourseSyllabus',

    data () {
        return {
            addUrl: urls.admin.course.detailsUrl.syllabus.addEdit
        };
    },

    methods: {
        formSuccess () {
            this.$notify('Successfully Added Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
